import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import fr from './locales/fr.json';

export const supportedLanguages = ['en', 'es', 'pt', 'fr'] as const;
export type SupportedLanguage = typeof supportedLanguages[number];

export const languageLabels: Record<SupportedLanguage, string> = {
  en: 'EN',
  es: 'ES',
  pt: 'PT',
  fr: 'FR',
};

export const languageNames: Record<SupportedLanguage, string> = {
  en: 'English',
  es: 'Español',
  pt: 'Português',
  fr: 'Français',
};

/**
 * Detect locale from URL path prefix: /en/..., /es/..., /pt/..., /fr/...
 */
const pathLocaleDetector = {
  name: 'pathLocale',
  lookup() {
    const match = window.location.pathname.match(/^\/(en|es|pt|fr)(\/|$)/);
    return match ? match[1] : undefined;
  },
};

const customLanguageDetector = new LanguageDetector();
customLanguageDetector.addDetector(pathLocaleDetector);

i18n
  .use(customLanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      pt: { translation: pt },
      fr: { translation: fr },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'es', 'pt', 'fr'],
    detection: {
      order: ['pathLocale', 'cookie', 'localStorage', 'navigator'],
      lookupCookie: 'greenin-language',
      lookupLocalStorage: 'greenin-language',
      caches: ['cookie', 'localStorage'],
      cookieMinutes: 525600, // 1 year
      // Map language variants to supported languages
      convertDetectedLanguage: (lng: string) => {
        const base = lng.split('-')[0].toLowerCase();
        if (['en', 'es', 'pt', 'fr'].includes(base)) return base;
        return 'en';
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
